<app-navbar-style-two></app-navbar-style-two>

<!-- <app-posnavbar></app-posnavbar> -->
<!-- <div class="banner-area-two client-slider owl-carousel owl-theme">
    <div class="client-item">
        <img src="https://medeilpos.blob.core.windows.net/websiteimage/opticalsoftware -medeilcloudpos.png" alt="optical software -medeilcloud pos">
        <div class="overlay-buttons row">
            <div class="col-lg-6">
                <button type="button" class="default-btn1">14 Days Free Trial</button>
            </div>
            <div class="col-lg-6">
                <button type="button" class="default-btn1" (click)="appointment('Opticals Vertical')">Demo Request</button>
            </div>
        </div>
    </div>
</div> -->
<div class="slider-area owl-carousel owl-theme">
  <div class="slider-item item-bg-optical">
      <div class="d-table">
          <div class="d-table-cell">
              <div class="container">
                  <div class="slider-content">
                      <h1 i18n>Optical Store Management Software & Solutions for Eyewear Retailers</h1>
                      <!-- <h3 i18n>Track Inventory, Manage Prescriptions, and Boost Sales with Ease</h3> -->
                          <button i18n type="button" class="default-btn" (click)="appointment('Optical Vertical')">Get Started Now</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<br>
<div class="container-md p-5 box-container">
    <p i18n style="color:white">Transform the way you run your optical business with Medeil’s advanced Optical Store Management Software. Designed for modern opticians and eyewear retailers, Medeil empowers you to automate daily operations, enhance customer service, and drive business growth—all from a single, intuitive platform.</p>
</div>
<br>



<ngx-smart-modal #enquirypos identifier="enquirypos" [closable]="false">


  <div class="custom-modal">
     <button class="close-btn" (click)="closeModal()">X</button>
     <div class="modal-header">
         <h5 i18n class="modal-title" id="exampleModalLabel">Enquiry Form</h5>
     </div>
       <div class="modal-body">
         <form [formGroup]="enquiryForm">
           <div class="form-group">
             <label i18n for="recipient-name" class="col-form-label"><strong>Name</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="leadname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Organisation</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="organizationname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Email</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="primaryemail" required>
             <div *ngIf="enquiryForm.controls.primaryemail.invalid && (enquiryForm.controls.primaryemail.dirty || enquiryForm.controls.primaryemail.touched)">
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.required" style="color: red;">Email is required.</div>
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.pattern" style="color: red;">Invalid email format.</div>
            </div>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Country</strong></label>
             <!-- <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="countryname1"> -->
             <select class="form-control"  formControlName="countryname1" style="font-size: 12px;" (change)="countrychange()">
              <!-- (change)="countrychange()" -->
              <option i18n select disabled value="0" >---Select Country---</option>
              <option  value="{{ country[1] }}" *ngFor="let country of totalcountry">{{country[1]}}</option>

            </select>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Mobile</strong><span class="star">*</span></label>
             <div class="row">
               <div class="col-lg-3">
                 <input type="text" name="rec" readonly class="form-control mobile-field" [(ngModel)]="dialcode" id="recipient-name" formControlName="phonedialcode">
               </div>
               <div class="col-lg-9">
                 <input type="text" name="rec" class="form-control mobile-field" maxlength="15" id="recipient-name" formControlName="primaryphone"
                 autocomplete="off" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')">
               </div>
             </div>

           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Description</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="address1">
           </div>
           <!-- <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Enter captcha</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name">
           </div> -->
           <label i18n for="message-text" class="col-form-label captchalabel"><strong>Enter captcha</strong></label>
           <div class="input-group">
              <input type="text" class="form-control ecaptcha" required formControlName="enteredcaptcha" required="required"
               (change)="checkCaptcha()"/>
              <input type="text" class="form-control gcaptcha" formControlName="generatedcaptcha" readonly
              [(ngModel)]="captcha"/>
              <i class="fa fa-arrows-rotate refresh" (click)="generatecaptcha()"></i>
            </div>
            <div *ngIf="ecaptcha">
              <p style="color: red">{{ errorcaptcha }}</p>
            </div>
           <div class="form-group">

                 <label i18n class="container1 mt-3">I Accept Terms & Conditions & MEDEIL Privacy Policy – Your Data Security & Rights
                     <input type="checkbox" checked="checked" formControlName="checkbox">
                     <span class="checkmark"></span>
                 </label>
           </div>
           <div class="btn-group mt-3" *ngIf="!showElement">
             <button i18n type="button" class="enquiry-btn" (click)="submitenquery()" >Submit</button>
           </div>
         </form>
       </div>
 </div>
</ngx-smart-modal>
<ngx-smart-modal #appointmentform identifier="appointmentform" [closable]="false">


  <div class="custom-modal"  >
     <button class="close-btn" (click)="closeModal()">X</button>
      <div class="modal-header-appointment">
          <h4 i18n class="modal-title" id="exampleModalLabel">Demo Request</h4>
      </div>
        <div class="modal-body">

           <div class="row">
              <div class="col-lg-12">
                 <mat-form-field >

                    <input matInput [matDatepicker]="picker" placeholder="Choose a date" (dateChange)="slectdate($event)" >
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                 </mat-form-field>

              </div>
              <div  align="center" *ngIf="showElement">
                 <img height="200px" width="200px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
               </div>
              <div class="col-lg-12" *ngIf="appointment_time">

                  <div class="button-container">
                    <button class="flex-button" *ngFor="let time of timeSlots" (click)="selectTime(time)" [ngClass]="{ 'clicked': selectedTime === time }">{{ time }}</button>
                </div>
                <div  align="center" *ngIf="showElementsave">
                  <img height="100px" width="100px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
                </div>
                  <div class="shedule-submit">
                    <button i18n class="shedulebtn" (click)="savelead()">Submit</button>
                  </div>
              </div>
           </div>

        </div>
  </div>
</ngx-smart-modal>
<div class="newslider" >

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/anu-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/apollo-hospitals.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bellamed-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bk-heart-hospital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/booncholai-super-market.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/emedsure.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/express-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/falcon-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/global-bridge-pharmaceutical.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/hawi-family-hostpital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/henry-jackson-foundation.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/imcri.webp" alt="image" height="200" width="300" priority>
  </div>

</div><!-- <div class="section-title container gradient-text mb-2" >

    <h2>Features</h2>
</div> -->
<!-- ---------------------------- -->


<div id="services" class="services section">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="section-heading  wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
            <div i18n class="gradient-text"><h2>Optical Store Software &amp; Manage Your Optical Business Seamlessly </h2>for you</div>
            <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
           <p i18n>Running an optical store involves more than just selling frames and lenses. From managing prescriptions and inventory to ensuring a smooth customer experience, the challenges can be overwhelming. That’s where Medeil’s Optical Store Software steps in – a smart, all-in-one solution designed to simplify your operations and help your business thrive.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <div class="service-item first-service">
            <div class="icon"></div>
            <h4 i18n>Save Time and Reduce Errors</h4>
            <p i18n>Automate repetitive tasks like inventory tracking and billing, so you can focus on your customers.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item second-service">
            <div class="icon"></div>
            <h4 i18n>Improve Customer Experience</h4>
            <p i18n>Provide faster, more personalized service with features like prescription management and CRM.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item third-service">
            <div class="icon"></div>
            <h4 i18n>Optimize Inventory</h4>
      <p i18n>
        Avoid overstocking or running out of popular items with real-time inventory tracking.
      </p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item fourth-service">
            <div class="icon"></div>
            <h4 i18n>Boost Profitability</h4>
             <p i18n>Use sales insights to identify trends, plan promotions, and increase revenue.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!-- ---------------------------- -->
<br>

<!-- key feature -->
<section class="about section-padding">
    <div class="section-title gradient-text ">
        <h3 i18n style="text-align: center;">Key Features of Medeil Optical Store Management Software</h3>
    </div>
    <h3 i18n style="text-align: center;">Experience a comprehensive suite of features built for the unique needs of optical store</h3>
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-12">
            </div>
            <div class="col-lg-10 col-12 ms-lg-auto mb-2 mb-lg-0 mt-2">
                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <button i18n class="nav-link active" id="nav-intro-tab" data-bs-toggle="tab"
                            data-bs-target="#nav-intro" type="button" role="tab" aria-controls="nav-intro"
                            aria-selected="true">Real-Time Inventory Management</button>

                        <button i18n class="nav-link" id="nav-profile-tab" data-bs-toggle="tab"
                            data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile"
                            aria-selected="false">Integrated Optical POS System</button>

                        <!-- <button class="nav-link" id="nav-faq-tab" data-bs-toggle="tab" data-bs-target="#nav-faq" type="button" role="tab" aria-controls="nav-faq" aria-selected="false">Real-Time Analytics</button> -->

                        <button i18n class="nav-link" id="nav-faq-inventory" data-bs-toggle="tab"
                            data-bs-target="#nav-faqinv" type="button" role="tab" aria-controls="nav-faqinv"
                            aria-selected="false">Prescription Management</button>

                        <button i18n class="nav-link" id="nav-faq-inventory" data-bs-toggle="tab"
                            data-bs-target="#nav-faqinv1" type="button" role="tab" aria-controls="nav-faqinv"
                            aria-selected="false">Customer Record Management</button>

                    </div>
                </nav>
            </div>

            <div class="col-12">
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-intro" role="tabpanel"
                        aria-labelledby="nav-intro-tab">
                        <div class="row mt-4">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/medicalshopbilling-medeilcloudpos.png"
                                    class="img-fluid" alt="medical shop billing-medeilcloudpos" width="500" height="400" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Real-Time Inventory Management</h3>
                                <p i18n> Track every frame, lens, and accessory with automated stock updates and low-inventory alerts to prevent out-of-stock situations.</p>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                        <div class="row mt-4">
                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Integrated Optical POS System</h3>

                                <p i18n>
                                    Speed up sales with a seamless point-of-sale experience, supporting multiple payment methods and quick billing.
                                </p>


                            </div>

                            <div class="col-lg-6 col-12 mt-lg-0 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/opticalmanagementsoftware - medeilcloud pos.png"
                                    class="img-fluid" alt="optical management software - medeilcloud pos"
                                    width="500" height="400" priority>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="nav-faqinv" role="tabpanel" aria-labelledby="nav-faq-inventory">
                        <div class="row">
                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Prescription Management</h3>
                                <p i18n>
                                    Digitally store, retrieve, and manage customer prescriptions with secure access and easy search functionality.
                                </p>
                            </div>
                            <div class="col-lg-6 col-12 mt-lg-0">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/pharmacy image.png"
                                    class="img-fluid" alt="pharmacy"  width="500" height="400" priority>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="nav-faqinv1" role="tabpanel" aria-labelledby="nav-finance">
                        <div class="row mt-4">
                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Customer Record Management</h3>
                                <p i18n>
                                    Maintain detailed customer profiles, including purchase history, prescription details, and communication logs for personalized service.
                                </p>
                            </div>

                            <div class="col-lg-6 col-12 mt-lg-0 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/pharmacypossystem - medeilcloud pos.png"
                                    class="img-fluid" alt="pharmacy pos system - medeilcloud pos" width="500" height="400" priority>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
    <div id="faq"></div>
</section>
<br>

<!-- end of key feature -->


<!-- start of why choose -->
<section class="hosbay-section">
    <div class="container">
        <div class="cta-section">
            <h2 i18n>Why Choose Medeil for Optical Store Operations?</h2>
            <p i18n>Medeil stands out for its user-friendly interface, robust security, and flexible modules that adapt to any optical retail environment. Whether you operate a single boutique or a multi-location chain, Medeil streamlines your workflow, reduces manual errors, and ensures compliance with industry standards. Our dedicated support team and regular software updates keep your business running smoothly and securely.</p>
            <button i18n type="button" class="default-btn" (click)="appointment('Contact Us')" style="height:60px; width:200px">Contact Us</button>
        </div>
    </div>
</section>

<!-- end of why choose -->



<!-- about  -->
<div id="about" class="about-us section">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 align-self-center">
        <div class="section-heading">
          <h4 i18n>What we do?</h4>
          <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
          <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
         <p i18n>At Vanuston, we specialize in developing state-of-the-art optical software solutions tailored to meet the unique needs of eyewear retailers, optometrists, and ophthalmologists</p>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="box-item" routerLink="/medeil">
                  <h5 i18n><a >Standalone Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="box-item" routerLink="/medeilcloudpos">
                  <h5 i18n><a >SaaS Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="box-item" routerLink="/medeilcloudhq">
                  <h5 i18n><a >Chain Store Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="box-item" routerLink="/allotmed">
                  <h5 i18n><a >Distribution Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-12 text-center">
                <div class="box-item" routerLink="/hosbay-healthcare">
                  <h5 i18n><a >Hospital Inventory Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
          <div class="col-lg-12">
            <p i18n>
                At Vanuston, we specialize in developing state-of-the-art optical software solutions tailored to meet the unique needs of eyewear retailers, optometrists, and ophthalmologists.
            </p>
            <div>
              <!-- <button class="gradient-button"> Start Free Trial</button> -->
             </div>
            <!-- <span>*No Credit Card Required</span> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="right-image">
          <img src="https://medeilpos.blob.core.windows.net/websiteimage/medeilcloudpos.gif" alt="medical pos billing- medeilcloud pos" loading="lazy">
        </div>
      </div>
    </div>
  </div>
</div>
<!-- ---- -->
<section class="optical-benefits-section">
  <div class="optical-container">
      <h3 i18n class="optical-title">Who Can Benefit from Medeil’s Optical Store Software?</h3>
      <p i18n class="optical-description">
          Our software is designed to streamline operations for various optical businesses, ensuring efficiency and seamless management.
      </p>

      <div class="optical-cards">
          <div class="optical-card">
              <div class="optical-icon"><i class="fas fa-glasses"></i></div>
              <h3 i18n>Independent Optical Stores</h3>
              <p i18n>Upgrade your optical store with modern solutions tailored for smooth operations.</p>
          </div>

          <div class="optical-card">
              <div class="optical-icon"><i class="fas fa-store-alt"></i></div>
              <h3 i18n>Chain Optical Stores</h3>
              <p i18n>Manage multiple store locations efficiently with our centralized system.</p>
          </div>

          <div class="optical-card">
              <div class="optical-icon"><i class="fas fa-eye"></i></div>
              <h3 i18n>Eye Clinics with Retail Sections</h3>
              <p i18n>Ensure seamless sales and inventory management for frames and lenses.</p>
          </div>

          <div class="optical-card">
              <div class="optical-icon"><i class="fas fa-eye"></i></div>
              <h3 i18n>Optical clinics & Centers</h3>
              <p i18n>Optical clinics and vision care centers requiring integrated prescription and sales management</p>
          </div>
      </div>
  </div>
</section>

<div class="container mt-4">
    <div class="section-title gradient-text mt-2 mb-2" >
        <h2 i18n>Frequently Asked Questions</h2>
    </div>
    <div class="row pt-4">
        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: Which functions are available in your optical software? </h4>
                <p i18n><strong>A:</strong> Clients frequently inquire about the features and functionalities of the platform, such as the ability to virtually try on items, manage frame inventories, schedule appointments, integrate with electronic health records (EHR), and access reporting tools.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: Does your optical software work with the systems and hardware we now have? </h4>
                <p i18n><strong>A:</strong> Yes, this inquiry pertains to compatibility issues with current hardware, including electronic health records (EHR), point-of-sale (POS) systems, and other software programs utilized by optical enterprises. Our solution is compatible with current computers, tablets, and smartphones.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q:  Is it possible to modify your optical program to meet our unique requirements? </h4>
                <p i18n><strong>A:</strong> Many optical firms want to know if the software can be customized to meet their specific demands because they have different requirements and workflows. Customizing fields, reports, processes, and integrations may fall under this category.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: How long does it take to get up and running, and what is the process like for implementation? </h4>
                <p i18n><strong>A:</strong> Optical firms frequently want to know about the implementation process, timeline, training options, and continuing support provided because it can be a substantial undertaking to implement new software. The SaaS application is our solution. Your subscription account can be activated in a matter of minutes.</p>
            </div>
        </div>
    </div>
</div>

<br>
<section class="box-container">
    <div class="container">
        <div class="cta-section">
            <h2 i18n>Secure, Scalable, and User-Friendly Optical Store ERP</h2>
            <p i18n>Medeil is more than just management software—it’s a complete ERP solution for optical businesses. Enjoy peace of mind with enterprise-grade security, effortless scalability as your business grows, and an intuitive interface that requires minimal training. Stay ahead of the competition and deliver outstanding service with Medeil.</p>
            <!-- <a i18n (click)="appointment('Medeil Cloud POS-Free Demo')" class="cta-button">🚀 Request a Free Demo</a> -->
        </div>
    </div>
</section>
<br>



<div class="row mb-3 mt-3" style="width: 100%;">
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Crowd Review</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.3/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Google</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.8/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Capterra</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.4/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Software Suggest</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.7/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>G2 Crowd</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.1/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Trust Radius</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.6/5.0</p>
        </div>
  </div>
</div>

<br>
<div class="container-md p-5 box-container">
  <h3 i18n style="color: white;">Call to Action</h3>
  <p i18n style="color: white;">Ready to elevate your optical business? Request a free demo of Medeil Optical Store Management Software and discover how our solution can transform your store’s efficiency and customer satisfaction.</p>
  <a i18n (click)="appointment('optical Demo')" class="cta-button">🚀 Request a Free Demo</a>
  </div>
<br>
<app-footer-style-two></app-footer-style-two>
